import axios from 'axios'
let parser = require('accept-language-parser');

export default async function ({ req, route, store, $config }) {
  var pathArr = route.path.split('/')
  var path = pathArr[1]
  var locale = store.state.locale
  store.dispatch('setBaseDomain', $config.baseDomain)
  store.dispatch('setLocalDomain', $config.localDomain)
  if (!locale && path) {
    let response
    try {
      response = await axios.get($config.baseDomain + path + '/settings/public.json')
    } catch(e) {
      if (req && req.headers && req.headers['accept-language']) {
        let language = parser.pick(['en', 'fi', 'sv', 'de', 'it', 'ru'], req.headers['accept-language'], { loose: true })
        if (language && language.substring) {
          language = language.substring(0, 2)
        }
        switch (language) {
          case 'fi':
            locale = 'fi_FI'
            break
          case 'sv':
            locale = 'sv_SE'
            break
          case 'de':
            locale = 'de_DE'
            break
          case 'it':
            locale = 'it_IT'
            break
          case 'es':
            locale = 'es_ES'
            break
          case 'fr':
            locale = 'fr_FR'
            break
          case 'ru':
            locale = 'ru_RU'
            break
          case 'nb':
            locale = 'nb_NO'
            break
          case 'en':
          default:
            locale = 'en_US'
            break
        }
        await store.dispatch('setLocale', locale)
      }
      return
    }
    locale = response.data.locale
    await store.dispatch('setLocale', locale)
  }
}